// Add this immediately after your DOMContentLoaded event listener

document.addEventListener("DOMContentLoaded", () => {
  const addVerifiedBadges = () => {
    const reviewAuthorWrappers = document.querySelectorAll('.jdgm-rev__author-wrapper');

    reviewAuthorWrappers.forEach(wrapper => {
      if (!wrapper.querySelector('.jdgm-rev__buyer-badge-wrapper')) {
        const badgeWrapper = document.createElement('span');
        badgeWrapper.className = 'jdgm-rev__buyer-badge-wrapper';

        const badge = document.createElement('span');
        badge.className = 'jdgm-rev__buyer-badge';

        badgeWrapper.appendChild(badge);
        wrapper.appendChild(badgeWrapper);
      }
    });
  };

  // Immediately execute once DOM is loaded
  addVerifiedBadges();

  // Observer to handle dynamically added review elements
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        addVerifiedBadges();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Fallback interval for dynamic content
  const intervalId = setInterval(addVerifiedBadges, 500);

  // Stop the interval after 10 seconds
  setTimeout(() => clearInterval(intervalId), 10000);
});
